export const MAIN_COLOR = "#28579c";
export const MAIN_COLOR_DARK = "#1d437d";
